// eslint-disable-next-line import/no-anonymous-default-export
export default (category = [], action) => {
  switch (action.type) {
    case "FETCH_ALL":
      return action.payload;

    case "CREATE_CATEGORY":
      return [...category, action.payload];

    case "UPDATE_CATEGORY":
      return category.map((item) =>
        item._id === action.payload._id ? action.payload : item,
      );

    case "DELETE_CATEGORY":
      return category.filter((item) => item._id !== action.payload);

    default:
      return category;
  }
};
